import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from '@/plugins/i18n';
import "video.js/dist/video-js.min.css";

const _ = require('lodash');

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");

let _resize = () => {
  store.dispatch('setW', window.innerWidth);
  store.dispatch('setH', window.innerHeight);
};
window.addEventListener("resize",_.debounce(_resize, 150));
